import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-rent',
    templateUrl: './rent.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RentComponent {

}